import { render, staticRenderFns } from "./WantToSell.vue?vue&type=template&id=26ed9ce8&scoped=true&"
import script from "./WantToSell.vue?vue&type=script&lang=ts&"
export * from "./WantToSell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ed9ce8",
  null
  
)

export default component.exports